import { CONFIG } from '../config';

export function DOIBadge({
  doi,
  interactive = true,
  reserved = false,
}: {
  doi?: string;
  interactive?: boolean;
  reserved?: boolean;
}) {
  if (!doi?.trim().length) {
    return null;
  }

  const isInteractive = !reserved && interactive;

  const doiUrl = CONFIG.LANDING_PAGE_LINK + doi;

  const doiLabel = (
    <div
      className="bg-black text-white"
      style={{
        padding: '2px 5px',
        display: 'inline-flex',
        alignItems: 'center',
      }}
      key="doilabel"
    >
      DOI
    </div>
  );

  const bg = reserved ? 'bg-warning' : 'bg-info';
  const className = `${bg} text-white text-decoration-none`;
  const doiLink = (
    <a
      href={isInteractive ? doiUrl : undefined}
      target={isInteractive ? '_blank' : undefined}
      rel={isInteractive ? 'noopener noreferrer' : undefined}
      className={className}
      style={{
        padding: '2px 5px',
        display: 'inline-flex',
        alignItems: 'center',
      }}
      key="doilink"
    >
      {doi.toLocaleUpperCase()}
    </a>
  );

  return (
    <div
      className="rounded"
      style={{
        display: 'inline-flex',
        overflow: 'hidden',
      }}
    >
      {doiLabel}
      {doiLink}
    </div>
  );
}
